var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-multiline mt-3 mr-2" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasSelected,
              expression: "hasSelected",
            },
          ],
          staticClass: "column",
        },
        [
          _vm._v(" Please select category: "),
          _c("div", { staticClass: "select" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.attachmentCategory,
                    expression: "attachmentCategory",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.attachmentCategory = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.attachmentCategories, function (m) {
                return _c(
                  "option",
                  {
                    key: m.quoteAttachmentCategoryId,
                    domProps: { value: m.quoteAttachmentCategoryId },
                  },
                  [_vm._v(_vm._s(m.name))]
                )
              }),
              0
            ),
          ]),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasSelected,
                  expression: "hasSelected",
                },
              ],
              staticClass: "button tooltip ml-2",
              attrs: { "data-tooltip": "Copy to quote" },
              on: {
                click: function ($event) {
                  return _vm.copyAttachmentToQuote(true)
                },
              },
            },
            [_vm._m(0)]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "column is-narrow",
          class: [{ "is-full": !_vm.hasSelected }],
        },
        [
          _c("p", { staticClass: "buttons is-justify-content-right" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isIncoming,
                    expression: "isIncoming",
                  },
                ],
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Select all" },
                on: {
                  click: function ($event) {
                    return _vm.setSelectedStatusAll(true)
                  },
                },
              },
              [_vm._m(1)]
            ),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSelected,
                    expression: "hasSelected",
                  },
                ],
                staticClass: "button tooltip",
                attrs: { "data-tooltip": "Deselect all" },
                on: {
                  click: function ($event) {
                    return _vm.setSelectedStatusAll(false)
                  },
                },
              },
              [_vm._m(2)]
            ),
          ]),
        ]
      ),
    ]),
    _c("div", [
      _c(
        "div",
        { staticClass: "columns is-multiline" },
        _vm._l(_vm.innerAttachments, function (attachment) {
          return _c(
            "div",
            {
              key: attachment.quoteEmailAttachmentId,
              staticClass: "column is-1 m-0 p-1",
            },
            [
              _c(
                "div",
                {
                  staticClass: "is-clickable is-unselectable py-0 px-0",
                  class: `has-background-${_vm.$theme.name}`,
                },
                [
                  _c("div", { staticClass: "columns is-gapless is-relative" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isIncoming,
                            expression: "isIncoming",
                          },
                        ],
                        staticClass: "button is-primary is-small px-1 m-0",
                        class: !attachment.isSelected
                          ? ["is-light", `is-light-btn-${_vm.$theme.name}`]
                          : "",
                        staticStyle: {
                          position: "absolute",
                          top: "0",
                          left: "0",
                          "z-index": "1",
                        },
                        on: {
                          click: () => {
                            attachment.isSelected = !attachment.isSelected
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-check",
                          class: {
                            "": attachment.isSelected,
                            "has-text-grey-light": !attachment.isSelected,
                          },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "column is-full is-clipped" }, [
                      _c(
                        "figure",
                        {
                          staticClass:
                            "image is-3by4 is-fullwidth is-vcentered",
                          on: {
                            click: function ($event) {
                              return _vm.viewImage(
                                attachment,
                                attachment.isImage
                              )
                            },
                          },
                        },
                        [
                          attachment.isImage
                            ? _c("img", {
                                staticStyle: { "object-fit": "cover" },
                                attrs: { src: attachment.externalStorageURL },
                              })
                            : _vm._e(),
                          attachment.isPdf
                            ? _c("img", {
                                attrs: {
                                  alt: "Vue logo",
                                  src: require("../../../assets/images/attachment-pdf.png"),
                                },
                              })
                            : _vm._e(),
                          !attachment.isImage && !attachment.isPdf
                            ? _c("img", {
                                attrs: {
                                  alt: "Vue logo",
                                  src: require("../../../assets/images/attachment-doc.png"),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "columns is-multiline column is-clipped p-0 m-0",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "column is-full p-0 m-0",
                              staticStyle: {
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                                "font-weight": "bold",
                                "white-space": "nowrap",
                              },
                              attrs: {
                                tooltip: attachment.filename,
                                title: attachment.filename,
                              },
                            },
                            [_vm._v(_vm._s(attachment.filename) + ")")]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm.isViewerModalOpen
                ? _c("quote-email-attachment-viewer-modal", {
                    attrs: {
                      active: _vm.isViewerModalOpen,
                      attachment: _vm.viewAttachment,
                      "quote-id": _vm.quoteId,
                      "is-incoming": _vm.isIncoming,
                    },
                    on: {
                      cancel: function ($event) {
                        return _vm.viewImage(null)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-content-copy mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }